import { useNavigate, useLocation } from "react-router-dom";
import { Phone, Mail, MessageCircle, FileText } from "lucide-react";

export const FloatingButtons = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const goQuote = () => {
    if (location.pathname !== "/") navigate("/#contact");
    else {
      const el = document.getElementById("contact");
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  };

  const btn =
    "flex items-center justify-center h-12 w-12 rounded-full shadow-lg transition-transform duration-200 hover:scale-110";

  return (
    <div
      data-testid="floating-buttons"
      className="fixed right-4 bottom-4 z-50 flex flex-col gap-3"
    >
      <a
        href="https://wa.me/917715972997"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="float-whatsapp"
        aria-label="WhatsApp"
        className={`${btn} bg-[#25D366] text-white`}
      >
        <MessageCircle className="h-5 w-5" />
      </a>
      <a
        href="tel:+917715972997"
        data-testid="float-call"
        aria-label="Call"
        className={`${btn} bg-[#10193f] text-white`}
      >
        <Phone className="h-5 w-5" />
      </a>
      <a
        href="mailto:info@snesar.com"
        data-testid="float-email"
        aria-label="Email"
        className={`${btn} bg-[#10193f] text-white`}
      >
        <Mail className="h-5 w-5" />
      </a>
      <button
        onClick={goQuote}
        data-testid="float-quote"
        aria-label="Request Quote"
        className={`${btn} bg-[#8b8f99] text-white`}
      >
        <FileText className="h-5 w-5" />
      </button>
    </div>
  );
};
